import type {
  DeleteDriverFailed,
  DeleteDriverRequest,
  DeleteDriverSucceeded,
  LoadDriversFailed,
  LoadDriversRequest,
  LoadDriversSucceeded,
  LoadTokenAssociationsFailed,
  LoadTokenAssociationsRequest,
  LoadTokenAssociationsSucceeded,
  OnDriverDataFormChange,
  SaveDriverFailed,
  SaveDriverRequest,
  SaveDriverSucceeded,
  SaveTokenAssociationFailed,
  SaveTokenAssociationRequest,
  SaveTokenAssociationSucceeded,
  TokenValidationFailed,
  TokenValidationRequest,
  TokenValidationSucceeded,
} from './actions';
import { DriverActionTypes } from './driverActionTypes';

import type { UUID } from '@cobliteam/common-types';

import type { Associations, Driver, NewDriver, TokenValidation } from '@cobliteam/api-lib';

export const loadDriversRequest = (): LoadDriversRequest => ({
  type: DriverActionTypes.LOAD_DRIVERS_REQUEST,
});

export const loadDriversSucceeded = (drivers: Driver[]): LoadDriversSucceeded => ({
  type: DriverActionTypes.LOAD_DRIVERS_SUCCEEDED,
  payload: drivers,
});

export const loadDriversFailed = (): LoadDriversFailed => ({
  type: DriverActionTypes.LOAD_DRIVERS_FAILED,
});

export const deleteDriverRequest = (driverId: UUID): DeleteDriverRequest => ({
  type: DriverActionTypes.DELETE_DRIVER_REQUEST,
  payload: { driverId },
});

export const deleteDriverSucceeded = (driverId: UUID): DeleteDriverSucceeded => ({
  type: DriverActionTypes.DELETE_DRIVER_SUCCEEDED,
  payload: { driverId },
});

export const deleteDriverFailed = (): DeleteDriverFailed => ({
  type: DriverActionTypes.DELETE_DRIVER_FAILED,
});

export const saveDriverRequest = (driver: Driver | NewDriver): SaveDriverRequest => ({
  type: DriverActionTypes.SAVE_DRIVER_REQUEST,
  payload: driver,
});

export const saveDriverSucceeded = (driverData: Driver | NewDriver, saveDriverResponseData: Driver): SaveDriverSucceeded => ({
  type: DriverActionTypes.SAVE_DRIVER_SUCCEEDED,
  payload: {
    driverData,
    saveDriverResponseData,
  },
});

export const saveDriverFailed = (): SaveDriverFailed => ({
  type: DriverActionTypes.SAVE_DRIVER_FAILED,
});

export const saveTokenAssociationRequest = (driverId: UUID, identifier: string): SaveTokenAssociationRequest => ({
  type: DriverActionTypes.SAVE_TOKEN_ASSOCIATION_REQUEST,
  payload: {
    driverId,
    identifier,
  },
});

export const saveTokenAssociationFailed = (): SaveTokenAssociationFailed => ({
  type: DriverActionTypes.SAVE_TOKEN_ASSOCIATION_FAILED,
});

export const saveTokenAssociationSucceeded = (driverId: UUID, identifier: string): SaveTokenAssociationSucceeded => ({
  type: DriverActionTypes.SAVE_TOKEN_ASSOCIATION_SUCCEEDED,
  payload: {
    driverId,
    identifier,
  },
});

export const tokenValidationRequest = (identifier: string): TokenValidationRequest => ({
  type: DriverActionTypes.TOKEN_VALIDATION_REQUEST,
  payload: identifier,
});

export const tokenValidationFailed = (): TokenValidationFailed => ({
  type: DriverActionTypes.TOKEN_VALIDATION_FAILED,
});

export const tokenValidationSucceeded = (tokenValidationData: TokenValidation): TokenValidationSucceeded => ({
  type: DriverActionTypes.TOKEN_VALIDATION_SUCCEEDED,
  payload: tokenValidationData,
});

export const loadTokenAssociationRequest = (): LoadTokenAssociationsRequest => ({
  type: DriverActionTypes.LOAD_TOKEN_ASSOCIATIONS_REQUEST,
});

export const loadTokenAssociationSucceeded = (associations: Associations): LoadTokenAssociationsSucceeded => ({
  type: DriverActionTypes.LOAD_TOKEN_ASSOCIATIONS_SUCCEEDED,
  payload: associations,
});

export const loadTokenAssociationFailed = (): LoadTokenAssociationsFailed => ({
  type: DriverActionTypes.LOAD_TOKEN_ASSOCIATIONS_FAILED,
});

export const onDriverDataFormChange = (driverData: object): OnDriverDataFormChange => ({
  type: DriverActionTypes.ON_DRIVER_DATA_FORM_CHANGE,
  payload: driverData,
});
